(function (angular) {
	'use strict';

	angular.module('manageBankAccountsModule', [
		'coreModule',
		'plaidModule',
		'settingsModule'
	]);
})(window.angular);